import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DeleteButton from '../fw/DeleteButton.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLabel} from '../fw/Tool';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'apiKeyView.title', 'defaultMessage': 'API Key'}
});

interface ApiKeyViewProps {
    intl: IntlShape;
    user: User;
}

class ApiKeyView extends React.Component<ApiKeyViewProps> {

    typeName = 'apiKeys';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            showSecret: false
        };
    }

    showSecret = () => {
        setTimeout(() => {
            this.setState({
                showSecret: false
            });
        }, 10000);
        this.setState({
            showSecret: true
        });
    }

    hideSecret = () => {
        this.setState({
            showSecret: false
        });
    }

    _onSuccess = () => {
        let url = urlMapping.getUrl(types['apiKeys'], 'list', {organisation_id: this.props.user.organisation.realId, ...this.props.user});
        this.context.router.push(url);
    };


    render() {
        let { apiKey } = this.props.user;

        let type = types[this.typeName];
        /* fake organisation_id to allow our URL system to work */
        apiKey['organisation_id'] = this.props.user.organisation.realId;

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)} titleAsHeader>
                <div className="event-page">

                    <DetailBox data={apiKey} metadata={type} urlMapping={urlMapping}>
                        <DetailToolBar data={apiKey} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping}>
                            <DeleteButton
                                data={apiKey}
                                deleteFatQuery={Relay.QL `fragment on DeleteApiKeyPayload {
                                                            updatedNode {
                                                                id
                                                            },
                                                            user {
                                                                apiKeys(first: 100) {
                                                                    edges {
                                                                        node {
                                                                            id
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        }`}
                                deleteMutation={Relay.QL `mutation { deleteApiKey }`}
                                metadata={type}
                                onSuccess={this._onSuccess}
                                organisationId={this.props.user.organisation.realId}
                                types={types}
                                urlMapping={urlMapping}
                            />
                        </DetailToolBar>

                        <h2>{apiKey.description ? <FormattedMessage defaultMessage="API Key: {realId}" id="invitation.title2" values={{realId: apiKey.description}}/> : <FormattedMessage defaultMessage="API Key" id="invitation.title3" />}</h2>


                        <TableDetail
							childrenBefore
							columns={['createdAt', 'validFrom', 'validTo']}
							data={apiKey} metadata={type}
						>
							<tr>
								<td style={{verticalAlign: 'middle'}}>{getLabel(types['apiKeys'], 'apiKey', this.props.intl.formatMessage)}:</td>
								<td>
									<div className="input-group">
                                        <input className="form-control" disabled type="text" value={this.state.showSecret ? (apiKey.apiKey ? apiKey.apiKey : '') : '******************'} /> {this.state.showSecret ?
                                        <div className="input-group-addon btn btn-default" onClick={this.hideSecret}><FormattedMessage defaultMessage="Hide key" id="invitation.hideSecret" /></div>
                                        :
                                        <div className="input-group-addon btn btn-default" onClick={this.showSecret}><FormattedMessage defaultMessage="Show key" id="invitation.showSecret" /></div>
                                        }
                                    </div>
								</td>
							</tr>
						</TableDetail>

                    </DetailBox>
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ApiKeyView), (props) => {
    return props.user.apiKey;
}), {
    initialVariables: {
        apiKeyId: '',
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                firstname,
                surname,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                },
                apiKey(id: $apiKeyId) {
                    id,
                    realId,
                    apiKey,
                    user_id,
                    validFrom,
                    validTo,
                    description,
                    createdAt,
                }
            }
        `,
    },
});
